module.exports = __webpack_public_path__ + "media/images/country_flags/fi-664d9849711080aedd7ded197b6f54b5.png";